export const CANONICAL_AUTH_ORIGIN = "https://app.myvisionassistant.com";

const BLUEPRINT_AUTH_ORIGIN = "https://blueprint.myvisionagency.com";

function normalizeOrigin(value?: string | null): string | null {
  if (!value) return null;

  try {
    return new URL(value).origin;
  } catch {
    return null;
  }
}

export function isLocalAuthOrigin(origin?: string | null): boolean {
  const normalized = normalizeOrigin(origin);
  if (!normalized) return false;

  try {
    const parsed = new URL(normalized);
    return (
      parsed.protocol === "http:" &&
      (parsed.hostname === "localhost" || parsed.hostname === "127.0.0.1")
    );
  } catch {
    return false;
  }
}

export function isBlueprintAuthOrigin(origin?: string | null): boolean {
  return normalizeOrigin(origin) === BLUEPRINT_AUTH_ORIGIN;
}

export function resolveCanonicalAuthOrigin(origin?: string | null): string {
  if (isLocalAuthOrigin(origin)) {
    return normalizeOrigin(origin) ?? CANONICAL_AUTH_ORIGIN;
  }

  return CANONICAL_AUTH_ORIGIN;
}

export function buildCanonicalAuthUrl(path: string, origin?: string | null): string {
  return new URL(path, resolveCanonicalAuthOrigin(origin)).toString();
}
